module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "print btn btn-primary hidden-print",
    class: {
      inline: _vm.inline
    },
    on: {
      "click": _vm.print
    }
  }, [_c('span', {
    staticClass: "fa fa-print fa-fw"
  }), _vm._v(" \n    Print\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77f3f887","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Print.vue
// module id = 402
// module chunks = 1